/* eslint-disable import/prefer-default-export */
import FolderSearchIcon from "../../assets/logos/FolderSearchIcon.svg";
import Applications from "../../assets/logos/Applications.svg";
import RevenueLoss from "../../assets/logos/RevenueLoss.svg";
import Trendup from "../../assets/logos/Trendup.svg";

export const benefitData = {
  agentName: "Benefits Agent",
  pageTitle: "Benefits Agent",
  title: "Benefits Agent",
  subtitle: "Agentic Apps",

  entries: [
    {
      icon: "BA",
      text: 'You have been <strong>assigned 5 applications</strong>.',
      meta: "just now",
      badge: "For Benefit Search",
      links: [
        { label: "Ask Benefits Agent", href: "#open" },
        { label: "View Application", href: "#details" },
      ],
    },
    {
      icon: "BA",
      text: 'You have been <strong>assigned case #1234</strong>.',
      meta: "2 hr ago",
      badge: "For Benefit Search",
      links: [
        { label: "Ask Benefits Agent", href: "#open" },
        { label: "View Application", href: "#details" },
      ],
    },
  ],

  actionItems: [
    {
      text: "Scanned Applications",
      type: "red",
      link: "#",
      linkText: "Ready for review",
      number: "10",
    },
  ],

};
